import { ChartDataResponse, DailyDataResponse, ApiError, UserSearchResponse } from '../types';

// 開発時はプロキシ、本番時はCloudFront経由でAPIにアクセス
// 本番環境のAPIエンドポイント
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';
const API_KEY = import.meta.env.VITE_API_KEY ?? '';

const apiHeaders = (): HeadersInit => ({
  'Content-Type': 'application/json',
  'X-API-Key': API_KEY,
});

export class ApiService {
  static async getChartData(
    userId: number,
    startDate: string,
    endDate: string
  ): Promise<ChartDataResponse> {
    try {
      const url = `${API_BASE_URL}/api/measurements/${userId}/chart?start_date=${startDate}&end_date=${endDate}`;
      console.log('API Request URL:', url);
      
      const response = await fetch(url, { headers: apiHeaders() });
      console.log('API Response Status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error Response:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();
      console.log('API Response Data:', data);
      return data;
    } catch (error) {
      console.error('API Service Error:', error);
      const apiError: ApiError = {
        message: error instanceof Error ? error.message : 'Unknown error occurred',
        status: error instanceof Error && 'status' in error ? (error as any).status : undefined,
      };
      throw apiError;
    }
  }

  static async getDailyData(
    userId: number,
    selectedDate: string
  ): Promise<DailyDataResponse> {
    try {
      const url = `${API_BASE_URL}/api/measurements/${userId}/daily/${selectedDate}`;
      console.log('API Request URL:', url);
      
      const response = await fetch(url, { headers: apiHeaders() });
      console.log('API Response Status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error Response:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();
      console.log('API Response Data:', data);
      return data;
    } catch (error) {
      console.error('API Service Error:', error);
      const apiError: ApiError = {
        message: error instanceof Error ? error.message : 'Unknown error occurred',
        status: error instanceof Error && 'status' in error ? (error as any).status : undefined,
      };
      throw apiError;
    }
  }

  static async checkHealth(): Promise<{ status: string; data_accessible: boolean }> {
    try {
      const response = await fetch(`${API_BASE_URL}/health`, { headers: apiHeaders() });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      throw new Error('Health check failed');
    }
  }

  static async searchUsers(
    name: string,
    email: string,
    startDate: string,
    endDate: string
  ): Promise<UserSearchResponse> {
    try {
      const params = new URLSearchParams();
      if (name) params.append('name', name);
      if (email) params.append('email', email);
      params.append('start_date', startDate);
      params.append('end_date', endDate);

      const url = `${API_BASE_URL}/api/users/search?${params.toString()}`;
      console.log('User Search API Request URL:', url);
      
      const response = await fetch(url, { headers: apiHeaders() });
      console.log('User Search API Response Status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('User Search API Error Response:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const data = await response.json();
      console.log('User Search API Response Data:', data);
      return data;
    } catch (error) {
      console.error('User Search API Service Error:', error);
      const apiError: ApiError = {
        message: error instanceof Error ? error.message : 'Unknown error occurred',
        status: error instanceof Error && 'status' in error ? (error as any).status : undefined,
      };
      throw apiError;
    }
  }
}